/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import employeesIcon from '../general/media/icons/employees.svg';
import locationIcon from '../general/media/icons/locationGrey.svg';
import './style/companies.css';

/**
 * CompaniesFront Component
 *
 * @param {Object} props - Component properties
 * @param {Object} props.item - The data item to be displayed on the front side of the card
 * @param {Function} props.onMoreInfo - Function to handle more info button click
 * @param {number} props.index - The index of the card in the list
 * @param {number} props.arrayLength - The total number of cards in the array
 * @param {number} props.position - The position of the card in the array
 *
 * @returns {JSX.Element} CompaniesFront component
 */
const CompaniesFront = ({ item, onMoreInfo, index, arrayLength, position }) => (
  <div className='card__side card__side--front'>
    {item && (
      <>
        <div className='card__upperBox'>
          {/* Display the current position and total number of items */}
          <p className='swipingStatus'>
            {position}{' '}
            <FormattedMessage id='tinbit.counter' defaultMessage='von' />{' '}
            {arrayLength}
          </p>
          {/* Display the company's image */}
          <img
            src={item.image}
            alt={item.name}
            className='card__image'
            loading='lazy'
          />
        </div>
        <div className='card__details'>
          {/* Display the company's industry */}
          <p className='card__details-text'>{item.industry}</p>
          {/* Display the company's name */}
          <h2 className='card__details-title'>{item.name}</h2>
          <hr className='card__divider' />
          <div className='card__facts'>
            <div className='card__facts-item'>
              <span className='card__facts-text'>
                <img src={employeesIcon} alt='' className='card__facts-icon' />{' '}
                <FormattedMessage
                  id='tinbit.employees'
                  defaultMessage='Beschäftigte'
                />
              </span>
              {/* Display the number of employees */}
              <h3 className='card__facts-value'>{item.employees}</h3>
            </div>
            <div className='card__facts-item'>
              <span className='card__facts-text'>
                <img src={locationIcon} alt='' className='card__facts-icon' />{' '}
                <FormattedMessage
                  id='tinbit.location'
                  defaultMessage='Standort'
                />
              </span>
              {/* Display the main location */}
              <h3 className='card__facts-value'>{item.main_location}</h3>
            </div>
          </div>
          {/* Button to view more information */}
          <button
            className='card__button card__button--more-info'
            onClick={index === 0 ? onMoreInfo : null}
            style={{ pointerEvents: index === 0 ? 'auto' : 'none' }}
            type='button'
          >
            <FormattedMessage
              id='tinbit.moreInformation'
              defaultMessage='Mehr Informationen'
            />
          </button>
        </div>
      </>
    )}
  </div>
);

export default CompaniesFront;
